import React, {Component} from "react";
import "./Contact.css";

import PageSection from "PageSection/PageSection";
import Header from "Header/Header";
import Input from "Input/Input";
import Button from "Button/Button";
import Loader from "Loader/Loader";
import Icon from "Icon/Icon";

import axios from "axios";
import {validateEmail} from "utils";
import text from "text";

const REQUEST_URL = "http://anguterman.com:3000/contact";

const STATE_NORMAL = 1;
const STATE_SUCCESS = 2;
const STATE_ERROR = 3;

export default class Contact extends Component
{
	constructor()
	{
		super();
		this.initialState = {state: STATE_NORMAL, sending: false};
		this.state = this.initialState;

		this.handleNameRef = this.handleNameRef.bind(this);
		this.handleEmailRef = this.handleEmailRef.bind(this);
		this.handleBodyRef = this.handleBodyRef.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.tryAgain = this.tryAgain.bind(this);
	}

	handleNameRef(ref)
	{
		this.nameRef = ref;
	}

	handleEmailRef(ref)
	{
		this.emailRef = ref;
	}

	handleBodyRef(ref)
	{
		this.bodyRef = ref;
	}

	handleSubmit()
	{
		let name = this.nameRef.getValue(),
			email = this.emailRef.getValue(),
			body = this.bodyRef.getValue();

		if(name.length > 4)
		{
			if(validateEmail(email))
			{
				if(body.length > 5)
				{
					let data = {name, email, body};
					this.setState({sending: true});

					axios
					.post(REQUEST_URL, data)
					.then((response) =>
					{
						if(response.status === 200)
						{
							this.setState({state: STATE_SUCCESS, sending: false, validationError: null});
						}
						else
						{
							this.setState({state: STATE_ERROR, sending: false, validationError: null});
						}
					})
					.catch((error) =>
					{
						this.setState({state: STATE_ERROR, sending: false, validationError: null});
					});
				}
				else this.setState({validationError: "Please enter a valid message."});
			}
			else this.setState({validationError: "Please enter a valid email."});
		}
		else this.setState({validationError: "Please enter a valid name."});
	}

	tryAgain()
	{
		this.setState(this.initialState);
	}

	render()
	{
		let variableElement;

		if(this.state.state === STATE_NORMAL)
		{
			variableElement = (
				<Loader enabler={this.state.sending} text="Sending" className="loader">
					<div className="form">
						{this.state.validationError &&
							<div className="error">
								<Icon>notification</Icon>

								<div className="content">
									{this.state.validationError}
								</div>
							</div>
						}

						<Input ref={this.handleNameRef} placeholder="Name" onChange={this.updateButton} />
						<Input ref={this.handleEmailRef} placeholder="Email" onChange={this.updateButton} />
						<Input ref={this.handleBodyRef} placeholder="Message" onChange={this.updateButton} multiline />

						<div className="submit">
							<Button onClick={this.handleSubmit}>Send</Button>
						</div>
					</div>
				</Loader>
			);
		}
		else if(this.state.state === STATE_SUCCESS)
		{
			variableElement = (
				<div className="text">
					<div className="head">
						Thank You
					</div>

					<div className="subhead">
						Your message has been received. I will try my best to reply to you within 24 hours.
					</div>
				</div>
			);
		}
		else if(this.state.state === STATE_ERROR)
		{
			variableElement = (
				<div className="text">
					<div className="head">
						Sorry about that
					</div>

					<div className="subhead">
						There was an error sending your message and it has been logged. Please try again later.
					</div>

					<div className="tryagain">
						<Button onClick={this.tryAgain}>Try Again</Button>
					</div>
				</div>
			);
		}

		return (
			<PageSection handleRef={this.props.handleRef} className="contact">
				<Header title="Contact" />

				<p className="headerMargin" dangerouslySetInnerHTML={{__html: text.CONTACT}}></p>

				{variableElement}
			</PageSection>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/Contact/Contact.js